// import ActionColumnRenderer from '../../../app/Table/renderer/ActionColumnRenderer';
import FoCasesModel from '../../../../../models/FoCloseCase';

import ActionColumnRenderer from "../../../../app/Table/renderer/ActionColumnRenderer";

export default class FoClosedCasesRendere extends ActionColumnRenderer<FoCasesModel> {
    getColumns() {
        return [
            // {
            //     name: "Sr. No.",
            //     selector: "id",
            //     width: "90px",
            //     cell: (_row: FoClosedCasesModel, index: number) => index + 1,
            // },
            {
                name: "Claim Number",
                selector: "claimNumber",
                cell: (row: FoCasesModel) => row.getClaimNumber(),
            },
            {
                name: "Client",
                selector: "clientName",
                cell: (row: FoCasesModel) => row.getClientName(),
            },
            {
                name: "Case Type",
                selector: "caseType",
                cell: (row: FoCasesModel) => row.getCaseTypeName(),
            },
            {
                name: "Insured Name",
                selector: "insuredName",
                cell: (row: FoCasesModel) => row.getInsuredName() || "-",
            },
            {
                name: "Insured Location",
                selector: "insuredLocation",
                cell: (row: FoCasesModel) => row.getInsuredLocation() || "-",
            },
            {
                name: "Investigator Name",
                selector: "investigatorName",
                cell: (row: FoCasesModel) => row.getInvestigatorName() || "-",
            },
            {
                name: 'Actions',
                selector: 'id',
                grow: 0,
                width: '180px',
                cell: this.renderActionColumn,
            },
        ];
    }
}
